export default __webpack_public_path__ + "static/media/misc-closetC.2b050d48.jpg";